<template>
    <!-- 已批改 -->
    <div class="work-correcteds" v-if="score_data">
        <div class="student-wfk-fenxi" v-if="score_data">
            <div class="fenxi-left">
                <div class="student-wfk-fenxi-cell">
                    <span class="cell-txt">优++</span>
                    <div class="fenxi-cell1">
                        <div class="fenxi-cell2" :style="'width:' + (score_data.a1 / corrected_number) * 100 + '%;'">
                        </div>
                    </div>
                    <span class="cell-txt-num">{{ score_data.a1 }}人</span>
                </div>
                <div class="student-wfk-fenxi-cell">
                    <span class="cell-txt">优+</span>
                    <div class="fenxi-cell1">
                        <div class="fenxi-cell2" :style="'width:' + (score_data.a2 / corrected_number) * 100 + '%;'">
                        </div>
                    </div>
                    <span class="cell-txt-num">{{ score_data.a2 }}人</span>
                </div>
                <div class="student-wfk-fenxi-cell">
                    <span class="cell-txt">优</span>
                    <div class="fenxi-cell1">
                        <div class="fenxi-cell2" :style="'width:' + (score_data.a3 / corrected_number) * 100 + '%;'">
                        </div>
                    </div>
                    <span class="cell-txt-num">{{ score_data.a3 }}人 </span>
                </div>
            </div>
            <div class="fenxi-right">
                <div class="student-wfk-fenxi-cell">
                    <span class="cell-txt">良+</span>
                    <div class="fenxi-cell1">
                        <div class="fenxi-cell2" :style="'width:' + (score_data.b1 / corrected_number) * 100 + '%;'">
                        </div>
                    </div>
                    <span class="cell-txt-num">{{ score_data.b1 }}人</span>
                </div>
                <div class="student-wfk-fenxi-cell">
                    <span class="cell-txt">良</span>
                    <div class="fenxi-cell1">
                        <div class="fenxi-cell2" :style="'width:' + (score_data.b2 / corrected_number) * 100 + '%;'">
                        </div>
                    </div>
                    <span class="cell-txt-num">{{ score_data.b2 }}人</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    data() {
        return {

        }
    },
    props: {
        score_data: {
            type: Object,
        },
        corrected_number: [Number]
    }

}
</script>

<style lang="scss" scoped>
.work-correcteds {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
}

.work-corrected-stat {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* fenxi------------ */
.student-wfk-fenxi {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    /* border: 1px solid red; */
}
.fenxi-left {
    width: 45%;
}

.fenxi-right {
    width: 45%;
}

.student-wfk-fenxi-cell {
    /* 	display: flex;
	flex-direction: row; */
    margin: 8px;
}

.student-wfk-fenxi-cell .cell-txt {
    width: 15%;
    display: inline-block;
}

.student-wfk-fenxi-cell .fenxi-cell1 {
    display: inline-block;
    width: 70%;
    margin: 0 8px 0 5px;
    padding: 5px 0;
    border-radius: 5px;
    position: relative;
    background-color: #f2f2f2;
}

.student-wfk-fenxi-cell .fenxi-cell2 {
    position: absolute;
    top: 0;
    left: 0;
    padding: 5px 0;
    border-radius: 5px;
    opacity: 0.7;
    background-color: #0063ff;
}

.student-wfk-fenxi-cell-active .cell-txt-num {
    color: #ff6600;
}

.student-wfk-fenxi-cell-active .fenxi-cell2 {
    background-color: #ff6600;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/CorrectedData.vue